import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { Action, AnyObject } from '@triare/auth-redux';
import {
  signInByService as signInByServiceAction,
  // signInByServiceError as signInByServiceErrorAction,
  SignInByServiceAction,
} from '@triare/auth-redux/dist/saga/auth/signIn';
import { useTranslation } from 'react-i18next';
import { IResolveParams, LoginSocialFacebook } from 'reactjs-social-login';
import { Error } from '@triare/auth-redux/dist/saga/common';
import { ContentProps } from '../../index';
import { RootState } from '../../../../../../store';
import { moduleName } from '../../../../../../store/auth';
import { IconFaceBook } from '../../../../../Common/Icon';

interface ButtonGoogleProps extends ContentProps {
  response: AnyObject | null;
  error: Error | null;
  signInByService: (payload: SignInByServiceAction) => Action;
  label?: string;
  // signInByServiceError: () => Action;
}

function ButtonFacebook({
  error,
  response,
  onSubmit,
  signInByService,
  label,
}: // signInByServiceError,
ButtonGoogleProps): React.ReactElement {
  const [signInData, setSignInData] = useState<SignInByServiceAction | null>(
    null,
  );
  const { t } = useTranslation();

  useEffect(() => {
    if (!error && response && onSubmit && signInData) {
      onSubmit(signInData);
    }
  }, [response, error, onSubmit, signInData]);

  // const [providerName, setProviderName] = useState('');

  const onLoginStart = useCallback(() => {
    // alert('login start')
  }, []);

  return (
    <LoginSocialFacebook
      isOnlyGetToken
      appId={process.env.REACT_APP_FB_APP_ID || ''}
      onLoginStart={onLoginStart}
      onResolve={({ provider, data }: IResolveParams) => {
        // setProviderName(provider);

        if (data && data.accessToken) {
          const payload: SignInByServiceAction = {
            // _query: {
            //   lang: 'en',
            // },
            method: 'facebook',
            accessToken: data.accessToken,
          };

          setSignInData(payload);
          signInByService(payload);
        }
      }}
      onReject={(err) => {
        console.log(err);
      }}
    >
      <Button
        style={{ width: '100%', fontWeight: 600, color: '#282C35' }}
        size="large"
        icon={<IconFaceBook />}
      >
        {label || 'Log in with Facebook'}
      </Button>
    </LoginSocialFacebook>
  );
}

export default connect(
  (state: RootState) => ({
    response: state[moduleName].signIn.response,
    error: state[moduleName].signIn.error,
  }),
  {
    signInByService: signInByServiceAction,
    // signInByServiceError: signInByServiceErrorAction,
  },
)(ButtonFacebook);
